export default function AddToArtlistIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={`add-to-artlist-icon ${className}`}
      onClick={onClick}
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="add-to-artlist-icon__outline"
        d="M398.92,101.08c-19.89-19.88-43.06-35.31-68.29-45.76-25.23-10.46-52.51-15.93-80.65-15.93-56.25,0-109.14,21.91-148.92,61.69-39.77,39.78-61.69,92.66-61.69,148.92s21.92,109.15,61.69,148.93c39.78,39.78,92.67,61.69,148.92,61.69s109.16-21.91,148.94-61.69c39.77-39.78,61.69-92.66,61.69-148.93s-21.92-109.14-61.69-148.92ZM250,414.26c-45.3,0-86.36-18.42-116.11-48.16-29.74-29.75-48.16-70.82-48.16-116.11,0-90.58,73.68-164.25,164.27-164.25s164.26,73.69,164.26,164.26-73.68,164.26-164.26,164.26Z"
      />
      <path
        className="add-to-artlist-icon__hover-fill"
        opacity="0"
        d="M250,85.74c-90.59,0-164.27,73.67-164.27,164.25,0,45.29,18.42,86.36,48.16,116.11,29.75,29.74,70.81,48.16,116.11,48.16,90.58,0,164.26-73.69,164.26-164.26s-73.68-164.26-164.26-164.26ZM326.81,270.54h-56.28v56.28c0,11.32-9.21,20.53-20.54,20.53s-20.53-9.21-20.53-20.53v-56.28h-56.28c-11.33,0-20.54-9.21-20.54-20.54s9.21-20.53,20.54-20.53h56.28v-56.28c0-11.33,9.21-20.54,20.53-20.54s20.54,9.21,20.54,20.54v56.28h56.28c11.32,0,20.53,9.21,20.53,20.53s-9.21,20.54-20.53,20.54Z"
      />
      <path
        className="add-to-artlist-icon__plus"
        d="M347.34,250c0,11.33-9.21,20.54-20.53,20.54h-56.28v56.28c0,11.32-9.21,20.53-20.54,20.53s-20.53-9.21-20.53-20.53v-56.28h-56.28c-11.33,0-20.54-9.21-20.54-20.54s9.21-20.53,20.54-20.53h56.28v-56.28c0-11.33,9.21-20.54,20.53-20.54s20.54,9.21,20.54,20.54v56.28h56.28c11.32,0,20.53,9.21,20.53,20.53Z"
      />
    </svg>
  );
}
